export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MAX_BREADCRUMBS_SIZE = 3;

export const TOAST_ERROR_TIME = 5000;

export const COMMON = 'common';
export const AUTO_CLOSE_DURATION = 5000;
export const MAX_FILE_SIZE_MB = 5;

export const DEFAULT_MOBILE_MAX_LENGTH = 18;

export const GEOLOCATION_TIMEOUT = 30 * 1000;
export const GEOLOCATION_MAXIMUM_AGE = 60 * 1000;
export const GEOLOCATION_UPDATE_INTERVAL = 60 * 1000;
